import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { Link, useNavigate } from "react-router-dom";
import "./css/raisefund.css";
import { useDisconnect, useAccount } from "wagmi";
import toast from "react-hot-toast";

export default function RaisedFund() {
  const navigate = useNavigate();
  const { address, isConnected } = useAccount();

  const sendToPresaleForm = () => {
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    navigate(`${config.baseUrl}presaleForm`);
    window.scrollTo(0, 0);
  };

  const sendToSwapForm = () => {
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    navigate(`${config.baseUrl}multichainSwapForm`);
    window.scrollTo(0, 0);
  };

  const showActive = () => {
    navigate(`${config.baseUrl}launchpad#activepresale`);
  };

  return (
    <>
      <section className="raisedFund bgStar position-relative pt-0 pb-0">
        {/* <div class="bg-shape">
          <img alt="" src="images/shape/bg-shape.png" />
        </div> */}
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center">
            <Col lg={12}>
              <div className="">
                <Card className="bg-transparent border-0">
                  <Card.Body>
                    <div className="text-center  position-relative mb-5">
                      <h1 className="text-white lh-sm mb-4">
                        Raise Funds, List Your Project, and Trade. Market Your
                        Initiative on
                        <span className="text-primary2"> INFI Launchpad.</span>
                      </h1>

                      <div className="">
                        <p className="fw-normal fs-2 text-light-grey2">
                          Are you developing the next game-changing blockchain
                          project? INFI Launchpad provides a streamlined
                          platform for project owners to raise funds, list their
                          projects, gain visibility and connect with a global
                          community of investors - ALL FREE OF CHARGE.
                        </p>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        variant="default"
                        className="btn-white-gradient text-black px-4 rounded-5 position-relative z-2 me-sm-3"
                        onClick={sendToPresaleForm}

                      >

                        <div className="d-flex gap-2 align-items-center">
                          <div className="lh-1">
                            RAISE A FUND
                            <div className="text-success text-uppercase x-small">
                            </div>
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="16"
                              viewBox="0 0 24 19"
                              fill="none"
                            >
                              <path
                                d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>

                      </Button>
                      <Button
                        as={Link}
                        to={`${config.baseUrl}platformInsight#disclaimer`}
                        className="px-4 rounded-5 bg-black  position-relative z-2 me-sm-3 border"

                      >

                        <div className="d-flex gap-2 align-items-center">
                          <div className="lh-1">
                            Disclaimer
                            {/* <div className="text-success text-uppercase x-small">
                              (Coming soon)
                            </div> */}
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="16"
                              viewBox="0 0 24 19"
                              fill="none"
                            >
                              <path
                                d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>

                      </Button>
                      <Button
                        className="px-4 rounded-5 bg-black  position-relative z-2 me-sm-3 border"
                        onClick={sendToSwapForm}
                        disabled
                      >

                        <div className="d-flex gap-2 align-items-center">
                          <div className="lh-1">
                            List Your Project
                            <div className="text-success text-uppercase x-small">
                              (Coming soon)
                            </div>
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="16"
                              viewBox="0 0 24 19"
                              fill="none"
                            >
                              <path
                                d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>

                      </Button>
                      <Button
                        variant="custombtn"
                        className="text-black px-4 rounded-5 position-relative z-2 text-uppercase"
                        onClick={showActive}
                        disabled
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <div className="lh-1">
                            Active Projects
                            <div className="text-success text-uppercase x-small">
                              (Coming soon)
                            </div>
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="16"
                              viewBox="0 0 24 19"
                              fill="none"
                            >
                              <path
                                d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
